import PostsSerializer from '@linc-technologies/linced-common/serializers/posts/base';

export default class PagePermission extends PostsSerializer {}
